module.exports = __webpack_public_path__ + "img/bna.986731fa.jpg";